<div class="w-[95vw] md:w-[80vw] lg:w-[75vw]">
  <app-modal-header>
    <div class="flex items-center">
      <svg-icon src="assets/icons/icon-degree.svg" class="my-1 w-8 text-theme-700"></svg-icon>
      <div class="ml-2 text-lg font-semibold text-theme-700" translate>trilhas.estudio.curso.trilhas</div>
      <hr app-modal-divider />
      <div class="text-md font-semibold">{{ data?.course?.titulo }}</div>
    </div>
  </app-modal-header>
  <div app-modal-content class="h-[75vh] !p-0 md:h-[calc(100vh_-_15rem)] xl:h-[80vh]">
    <ng-container *ngIf="(loading$ | async) === false; else loading">
      <div class="h-full overflow-auto py-8" *ngIf="subdivisionBar$ | async as subdivisions; else loading">
        <div class="flex flex-wrap justify-center gap-4 px-10">
          <div *ngFor="let subdivision of subdivisions">
            <app-card
              (click)="onOpenSubdivision(subdivision)"
              class="h-full w-80 cursor-pointer items-stretch !rounded-2xl !border-2 !border-theme-50 bg-theme-200 !px-3 pt-3 duration-500 hover:!border-theme-500 hover:shadow-lg"
            >
              <div class="self-center">
                <img
                  [src]="subdivision.thumbnail"
                  onerror="this.src='../../../../../assets/images/default.png'"
                  alt="img_subdivision"
                  class="w-full !rounded-xl"
                />
              </div>
              <div class="w-full border-b-2 border-theme-100 bg-white py-1 shadow-2xl"></div>
              <div
                *ngIf="!!subdivision?.progresso_user"
                class="mt-3 h-1.5 w-full rounded-full bg-gray-200"
                app-tooltip
                tooltip="{{ subdivision.progresso_user.porcentagem }}%"
              >
                <div
                  class="h-1.5 rounded-full"
                  [style.width.%]="subdivision.progresso_user.porcentagem"
                  [ngClass]="{
                    'bg-[#f59e0b]': subdivision.progresso_user.porcentagem <= 30,
                    'bg-blue-500':
                      subdivision.progresso_user.porcentagem >= 31 && subdivision.progresso_user.porcentagem <= 90,
                    'bg-green-500': subdivision.progresso_user.porcentagem >= 91
                  }"
                ></div>
              </div>
              <div class="items-start px-3 py-4">
                <p class="text-left text-md font-bold">{{ subdivision.titulo }}</p>
              </div>
            </app-card>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #loading>
      <div class="flex flex-wrap justify-center gap-4 px-10 py-8">
        <div *ngFor="let item of [1, 2, 3, 4]">
          <app-card class="h-96 w-80 !rounded-2xl !border-2 !border-theme-50 bg-theme-200 !px-3">
            <app-skeleton></app-skeleton>
          </app-card>
        </div>
      </div>
    </ng-template>
  </div>
</div>
